import Vue from 'vue'
import Router from 'vue-router'
import i18n from '../i18n'
Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/privacy', component: () => import('@/views/policy/privacy'), hidden: true},
  {path: '/homer', component: () => import('@/views/refer/index'), hidden: true},
  {path: '/term', component: () => import('@/views/policy/term'), hidden: true},
  {path: '/register', component: () => import('@/views/register/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {title: i18n.t('router.home'), icon: 'home'},
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: i18n.t('router.shop'), icon: 'dashboard'}
    }]
  }
]

export const asyncRouterMap = [
  {
    path:'/member',
    component: Layout,
    name: 'member',
    meta: {title: i18n.t('router.user'), icon: 'sms'},
    children: [
      {
        path: 'memberList',
        name: 'memberList',
        component: () => import('@/views/member/index'),
        meta: {title: i18n.t('router.userList'), icon: 'sms-flash'}
      }
    ]
  },
  {
    path:'/pay',
    component: Layout,
    name: 'pay',
    meta: {title: i18n.t('router.pay'), icon: 'sms'},
    children: [
      {
        path: 'index',
        name: 'payIndex',
        component: () => import('@/views/pay/index'),
        meta: {title: i18n.t('router.pay'), icon: 'sms-flash'}
      }
    ]
  },
  {
    path: '/shop',
    component: Layout,
    name: 'shop',
    meta: {title: i18n.t('router.menuShop'), icon: 'product'},
    children: [
      {
        path: 'shopList',
        name: 'shopList',
        component: () => import('@/views/shop/index'),
        meta: {title: i18n.t('router.shopList'), icon: 'product-list'}
      },
      {
        path: 'addShop',
        name: 'addShop',
        component: () => import('@/views/shop/add'),
        meta: {title: i18n.t('router.addShop'), icon: 'product-list'}
      },
      {
        path: 'updateShop',
        name: 'updateShop',
        component: () => import('@/views/shop/update'),
        meta: {title: i18n.t('router.updateShop'), icon: 'product-list'},
        hidden: true
      }
    ]
  },
  {
    path: '/mold',
    component: Layout,
    redirect: '/mold/kmold',
    name: 'kmold',
    meta: {title: "刀模具管理", icon: 'order'},
    children: [
      {
        path: 'kmold',
        name: 'kmold',
        component: () => import('@/views/mold/index'),
        meta: {title: i18n.t('router.orderList'), icon: 'product-list'}
      
    }]
  },

  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: i18n.t('router.order'), icon: 'order'},
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {title: i18n.t('router.orderList'), icon: 'product-list'}
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {title: i18n.t('router.orderDetail')},
        hidden: true
      },
      // {
      //   path: 'orderExcel',
      //   name: 'orderExcel',
      //   component: () => import('@/views/oms/order/orderExcel'),
      //   meta: {title: '订单表格'},
      //   hidden: true
      // },
      {
        path: 'balanceList',
        name: 'balanceList',
        component: () => import('@/views/oms/balance/index'),
        meta: {title: i18n.t('router.orderDetail')},
      },
      {
        path: 'deliverOrderList',
        name: 'deliverOrderList',
        component: () => import('@/views/oms/order/deliverOrderList'),
        meta: {title: i18n.t('router.deliverOrderList')},
        hidden: true
      },
      {
        path: 'orderSetting',
        name: 'orderSetting',
        component: () => import('@/views/oms/order/setting'),
        meta: {title: i18n.t('router.orderSetting'), icon: 'order-setting'}
      },
      {
        path: 'returnApply',
        name: 'returnApply',
        component: () => import('@/views/oms/apply/index'),
        meta: {title: i18n.t('router.returnApply'), icon: 'order-return'}
      },
      {
        path: 'returnReason',
        name: 'returnReason',
        component: () => import('@/views/oms/apply/reason'),
        meta: {title: i18n.t('router.returnReason'), icon: 'order-return-reason'}
      },
      {
        path: 'returnApplyDetail',
        name: 'returnApplyDetail',
        component: () => import('@/views/oms/apply/applyDetail'),
        meta: {title: i18n.t('router.returnApplyDetail')},
        hidden: true
      }
    ]
  },
  // {
  //   path: '/sms',
  //   component: Layout,
  //   name: 'sms',
  //   redirect: '/sms/advertise',
  //   meta: {title: i18n.t('router.marketing'), icon: 'sms'},
  //   children: [
  //     {
  //       path: 'flash',
  //       name: 'flash',
  //       component: () => import('@/views/sms/flash/index'),
  //       meta: {title: i18n.t('router.flashSale'), icon: 'sms-flash'}
  //     },
  //     {
  //       path: 'flashSession',
  //       name: 'flashSession',
  //       component: () => import('@/views/sms/flash/sessionList'),
  //       meta: {title: i18n.t('router.flashSession')},
  //       hidden: true
  //     },
  //     {
  //       path: 'selectSession',
  //       name: 'selectSession',
  //       component: () => import('@/views/sms/flash/selectSessionList'),
  //       meta: {title: i18n.t('router.selectSession')},
  //       hidden: true
  //     },
  //     {
  //       path: 'flashProductRelation',
  //       name: 'flashProductRelation',
  //       component: () => import('@/views/sms/flash/productRelationList'),
  //       meta: {title: i18n.t('router.flashProductRelation')},
  //       hidden: true
  //     },
  //     {
  //       path: 'coupon',
  //       name: 'coupon',
  //       component: () => import('@/views/sms/coupon/index'),
  //       meta: {title: i18n.t('router.couponList'), icon: 'sms-coupon'}
  //     },
  //     {
  //       path: 'addCoupon',
  //       name: 'addCoupon',
  //       component: () => import('@/views/sms/coupon/add'),
  //       meta: {title: i18n.t('router.addCoupon')},
  //       hidden: true
  //     },
  //     {
  //       path: 'updateCoupon',
  //       name: 'updateCoupon',
  //       component: () => import('@/views/sms/coupon/update'),
  //       meta: {title: i18n.t('router.updateCoupon')},
  //       hidden: true
  //     },
  //     {
  //       path: 'couponHistory',
  //       name: 'couponHistory',
  //       component: () => import('@/views/sms/coupon/history'),
  //       meta: {title: i18n.t('router.couponHistory')},
  //       hidden: true
  //     },
  //     {
  //       path: 'brand',
  //       name: 'homeBrand',
  //       component: () => import('@/views/sms/brand/index'),
  //       meta: {title: i18n.t('router.brandRecommendation'), icon: 'product-brand'}
  //     },
  //     {
  //       path: 'new',
  //       name: 'homeNew',
  //       component: () => import('@/views/sms/new/index'),
  //       meta: {title: i18n.t('router.newProduct'), icon: 'sms-new'}
  //     },
  //     {
  //       path: 'hot',
  //       name: 'homeHot',
  //       component: () => import('@/views/sms/hot/index'),
  //       meta: {title: i18n.t('router.popularProduct'), icon: 'sms-hot'}
  //     },
  //     {
  //       path: 'subject',
  //       name: 'homeSubject',
  //       component: () => import('@/views/sms/subject/index'),
  //       meta: {title: i18n.t('router.specialTopic'), icon: 'sms-subject'}
  //     },
  //     {
  //       path: 'advertise',
  //       name: 'homeAdvertise',
  //       component: () => import('@/views/sms/advertise/index'),
  //       meta: {title: i18n.t('router.advertiseList'), icon: 'sms-ad'}
  //     },
  //     {
  //       path: 'addAdvertise',
  //       name: 'addHomeAdvertise',
  //       component: () => import('@/views/sms/advertise/add'),
  //       meta: {title: i18n.t('router.addAdvertise')},
  //       hidden: true
  //     },
  //     {
  //       path: 'updateAdvertise',
  //       name: 'updateHomeAdvertise',
  //       component: () => import('@/views/sms/advertise/update'),
  //       meta: {title: i18n.t('router.editAdvertise')},
  //       hidden: true
  //     }
  //   ]
  // },

  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: i18n.t('router.permission'), icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: i18n.t('router.userList'), icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: i18n.t('router.roleList'), icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: i18n.t('router.allocMenu')},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: i18n.t('router.allocResource')},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: i18n.t('router.menuList'), icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: i18n.t('router.addMenu')},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: i18n.t('router.updateMenu')},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: i18n.t('router.resourceList'), icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: i18n.t('router.resourceCategory')},
        hidden: true
      },
      {
        path: 'group',
        component: () => import('@/views/ums/group/index'),
        name: 'Group',
        meta: {title: '用户分组', icon: 'list'}
      },
      {
      path: 'user_group',
      name: 'user_group',
      component: () => import('@/views/user_group/index'),

      meta: {title: "用户分组管理", icon: 'order'},
      
    },
      {
      path: 'capacity',
      name: 'capacity',
      component: () => import('@/views/CapacityWarning'),

      meta: {title: "产能预警", icon: 'order'},

    }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]


export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap.concat(asyncRouterMap) // Include asyncRouterMap for dynamic routes
})




// WEBPACK FOOTER //
// ./src/router/index.js